import Avatar from "@mui/material/Avatar";
import AvatarGroup from "@mui/material/AvatarGroup";
import { avatarSx } from "globalStyles";

const ListingStaffAvatarGroup = ({ staff = []}) => {
    if (!staff.length) return "-";
    return (
        <AvatarGroup
            max={4}
            componentsProps={{
                additionalAvatar: {
                    sx: avatarSx,
                    title: staff
                        .slice(4)
                        .map(s => s.full_name)
                        .join(", "),
                }
            }}
        >
            {staff.map((s, idx) => (
                <Avatar
                    key={idx}
                    title={s.full_name}
                    size="sm"
                    variant="soft"
                    sx={avatarSx}
                >
                    {s.full_name.charAt(0) + (s.full_name.includes(' ') ? s.full_name.split(' ')[1]?.charAt(0) || '' : s.full_name.charAt(1) || '')}
                </Avatar>
            ))}
        </AvatarGroup>
    );
};

export default ListingStaffAvatarGroup;